import { render, staticRenderFns } from "./yxType.vue?vue&type=template&id=432ffb4a&scoped=true"
import script from "./yxType.vue?vue&type=script&lang=js"
export * from "./yxType.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "432ffb4a",
  null
  
)

export default component.exports